import { dispatch } from 'api/redux'
import { setPrintConfig } from 'api/redux/store/application.actions'
import { type LabelType } from 'types'

import { mainSplitApi } from './redux/mainSplitApi'

export const printConfigApi = mainSplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getPrintConfig: builder.query<LabelType[], void>({
      query: () => {
        return {
          url: '/printconfig',
          method: 'GET'
        }
      },
      transformResponse: (response: LabelType[]) => {
        dispatch(setPrintConfig(response))
        return response
      }
    })
  }),
  overrideExisting: false
})

export const { useGetPrintConfigQuery } = printConfigApi
